export const DASHBOARD_ORDER_ROW_HEIGHT = 52
export const DASHBOARD_VISIBLE_ORDER_ITEMS = 1.5
export const DASHBOARD_ACTION_LIMIT = 8

export const DASHBOARD_CARD_VARIANTS = {
  current: {
    card: 'bg-gradient-to-br from-teal-50/90 via-white to-emerald-50/50',
    fade: 'bg-gradient-to-t from-emerald-50/90 to-transparent',
    icon: 'text-teal-600',
  },
  previous: {
    card: 'bg-gradient-to-br from-stone-50/90 via-white to-slate-100/60',
    fade: 'bg-gradient-to-t from-slate-100/90 to-transparent',
    icon: 'text-muted-foreground',
  },
} as const

export type DashboardCardVariant = keyof typeof DASHBOARD_CARD_VARIANTS
